












import Vue from 'vue';
import { mapGetters } from 'vuex';
import MStoreQuickActions from '@/components/shared/MStoreQuickActions.vue';
import CabinetConfigurationMakeChangesLock from '@/components/configuration/CabinetConfigurationMakeChangesLock.vue';
import { MStoreDashboardButtonModel, FontAwesomeIcons, StoreConstants, Configuration } from '@/types';

export default Vue.extend({
  computed: {
    ...mapGetters(StoreConstants.CabinetConfiguration.ModuleName, [StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationLockHeldByCurrentSession]),
    dashboardButtons(this: any) {
      return [
        {
          icon: FontAwesomeIcons.Plus,
          text: 'Add Cabinet',
          routeName: 'addCabinet',
          routeParams: {},
          isDisabled: !this.cabinetConfigurationLockHeldByCurrentSession
        },
        {
          icon: FontAwesomeIcons.Shield,
          text: 'Global Cabinet Permissions',
          routeName: Configuration.Cabinet.GlobalCabinetSecurityConfiguration.name,
          routeParams: {}
        }
      ] as MStoreDashboardButtonModel[];
    }
  },
  components: {
    MStoreQuickActions,
    CabinetConfigurationMakeChangesLock
  }
});
